module.exports = __webpack_public_path__ + "img/19.087cf543.png";